import { ref, onMounted } from 'vue';
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-e337b8d6"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "filter-content"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "page-title"
}, "日志查询", -1));
const _hoisted_3 = {
  class: "filter-list-content"
};
const _hoisted_4 = {
  class: "input-select-content"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "list-title"
}, "条件：", -1));
const _hoisted_6 = {
  class: "btn-content"
};
import { queryOpsModule, queryTypeModule } from '@/api/logApi';
import { dateFormat, OK } from '@/common';
import { queryAllUsers } from '@/api/permission';
import dayjs from 'dayjs';
export default /*#__PURE__*/_defineComponent({
  __name: 'LogFilterBlock',
  emits: ['filterSubmit'],
  setup(__props, {
    emit
  }) {
    const logType = ref(null),
      tag = ref(null),
      operatorName = ref(null),
      moduleList = ref([]),
      opsList = ref([]),
      userList = ref([]),
      timeArr = ref([]);
    const filterSubmit = () => {
        var _timeArr$value;
        let params = {
          logType: logType.value,
          tag: tag.value,
          operatorName: operatorName.value,
          beforeCreateDate: '',
          afterCreateDate: ''
        };
        if ((_timeArr$value = timeArr.value) !== null && _timeArr$value !== void 0 && _timeArr$value.length) {
          params.beforeCreateDate = dayjs(timeArr.value[0]).format(dateFormat);
          params.afterCreateDate = dayjs(timeArr.value[1]).format(dateFormat);
        }
        emit('filterSubmit', params);
      },
      getModule = async () => {
        try {
          const {
            code,
            data
          } = await queryOpsModule();
          if (code === OK) {
            opsList.value = data === null || data === void 0 ? void 0 : data.map(item => {
              return {
                value: item.typeName,
                label: item.typeName
              };
            });
          }
        } catch (e) {}
      },
      getTypeModule = async () => {
        try {
          const {
            code,
            data
          } = await queryTypeModule();
          if (code === OK) {
            moduleList.value = data === null || data === void 0 ? void 0 : data.map(item => {
              return {
                value: item.typeName,
                label: item.typeName
              };
            });
          }
        } catch (e) {}
      },
      getUserList = async () => {
        let params = {
          currentPage: 1,
          pageSize: 10000
        };
        try {
          const {
            pageUserInfo,
            code
          } = await queryAllUsers(params);
          if (code === '0000') {
            userList.value = pageUserInfo.map(item => {
              return {
                label: item.name,
                value: item.name
              };
            });
          }
        } catch (e) {}
      },
      init = () => {
        logType.value = null;
        tag.value = null;
        operatorName.value = null;
        timeArr.value = [];
        filterSubmit();
      };
    onMounted(() => {
      getModule();
      getTypeModule();
      getUserList();
    });
    return (_ctx, _cache) => {
      const _component_a_select = _resolveComponent("a-select");
      const _component_a_range_picker = _resolveComponent("a-range-picker");
      const _component_a_button = _resolveComponent("a-button");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_hoisted_5, _createVNode(_component_a_select, {
        "allow-clear": "",
        placeholder: "全部模块",
        options: moduleList.value,
        value: logType.value,
        "onUpdate:value": _cache[0] || (_cache[0] = $event => logType.value = $event)
      }, null, 8, ["options", "value"]), _createVNode(_component_a_select, {
        "allow-clear": "",
        placeholder: "操作类型",
        options: opsList.value,
        value: tag.value,
        "onUpdate:value": _cache[1] || (_cache[1] = $event => tag.value = $event)
      }, null, 8, ["options", "value"]), _createVNode(_component_a_select, {
        "allow-clear": "",
        placeholder: "操作人",
        "show-search": "",
        options: userList.value,
        value: operatorName.value,
        "onUpdate:value": _cache[2] || (_cache[2] = $event => operatorName.value = $event)
      }, null, 8, ["options", "value"]), _createVNode(_component_a_range_picker, {
        placeholder: ['操作时间', '操作时间'],
        value: timeArr.value,
        "onUpdate:value": _cache[3] || (_cache[3] = $event => timeArr.value = $event)
      }, null, 8, ["value"])]), _createElementVNode("div", _hoisted_6, [_createVNode(_component_a_button, {
        onClick: init
      }, {
        default: _withCtx(() => [_createTextVNode("重置")]),
        _: 1
      }), _createVNode(_component_a_button, {
        type: "primary",
        onClick: filterSubmit
      }, {
        default: _withCtx(() => [_createTextVNode("搜索")]),
        _: 1
      })])])]);
    };
  }
});